// eslint-disable-next-line import/no-cycle
import profileService from '@client/services/profile';

const getters = {};
const stateObj = {};

const actions = {
  async getClientInfo({commit, rootGetters}) {
    const clUserId = rootGetters['cognitoUser/userId'];
    const accountStatus = rootGetters['account/requests/overallStatus'];
    const client = await profileService.getClientInfo({clUserId});
    let sameMailing = false;

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (accountStatus && accountStatus.diff_mail_add !== null) {
      sameMailing = `${accountStatus.diff_mail_add}` !== 0;
    }

    if (client?.mailingAddress && client?.mailingAddress?.mailingActive !== null) {
      sameMailing = client.mailingAddress.mailingActive !== 1;
    }

    const mailingAddress = {
      ...client.mailingAddress,
      street_address: client.mailingAddress?.addressLine1,
      zipcode: client.mailingAddress?.zip,
    };

    commit('user/SET_CLIENT', {...client, sameMailing}, {root: true});
    commit('user/SET_MAILING_ADDRESS', mailingAddress, {root: true});
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
};
